import React, { useContext } from "react";
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  StyleSheet,
  DeviceEventEmitter,
  Dimensions,
} from "react-native";
import { colors } from "../context/Colors";
import AppContext from "../context";
import Icon from "react-native-vector-icons/Ionicons";
import { useColorScheme } from "react-native-appearance";
import { useNavigation, useFocusEffect } from "@react-navigation/native";
import { AnimatedCircularProgress } from "react-native-circular-progress";
import { View as DView } from "dripsy";

export default function Progress() {
  const navigation = useNavigation();
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { tour, gameMenuHeight, setGameMenuHeight, dict, setInGameStats } =
    useContext(AppContext);
  useFocusEffect(() => {
    //setGameMenuHeight(Dimensions.get('screen').height - 150);
  });

  const isStopLocked = (k) => {
    return (
      k <= tour.unlockedStop ||
      (!tour.stops[k - 1].challenges.length && k === tour.unlockedStop + 1)
    );
  };

  return (
    <View
      style={{
        padding: 10,
        borderRadius: 10,

        height: gameMenuHeight,
      }}
      // onLayout={(e) => {
      //   setGameMenuHeight(e.nativeEvent.layout.height);
      // }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <TouchableOpacity
          style={{ padding: 10, marginLeft: -10 }}
          onPress={() => navigation.goBack()}
        >
          <Icon name="chevron-back" color={colors[theme].text} size={22} />
        </TouchableOpacity>
        <Text
          style={{
            color: colors[theme].text,
            fontSize: 19,
            fontWeight: "600",
            flex: 1,
            textAlign: "center",
          }}
        >
          {dict.progress}
        </Text>
        <View style={{ width: 34 }} />
      </View>
      <ScrollView>
        <DView
          sx={{
            flexDirection: ["column", "row"],
            alignItems: "center",
            marginBottom: [10, 40],
          }}
        >
          <View
            style={{
              alignItems: "center",
              marginTop: 20,
              paddingHorizontal: 40,
            }}
          >
            <AnimatedCircularProgress
              size={160}
              width={10}
              fill={
                ((tour.challengesLost + tour.challengesWon) /
                  tour.totalChallenges) *
                100
              }
              tintColor="#23A7F1"
              // tintColorSecondary="#00FF00"
              rotation={0}
              // dashedTint={{ width: 10, gap: 2 }}
              backgroundColor={colors[theme].buttonBorder}
              // dashedBackground={{ width: 10, gap: 2 }}
              duration={1000}
              lineCap={"round"}
              children={() => (
                <View style={{ alignItems: "center" }}>
                  <Text
                    style={{
                      color: "#23A7F1",
                      fontWeight: "600",
                      fontSize: 84,
                    }}
                  >
                    {tour.challengesLost + tour.challengesWon}
                  </Text>
                  <Text
                    style={{
                      color: colors[theme].text,
                      marginTop: -10,
                      fontSize: 12,
                    }}
                  >
                    <Text style={{ opacity: 0.5 }}>{dict.of}</Text>{" "}
                    {tour.totalChallenges}
                  </Text>
                </View>
              )}
            />
            <Text
              style={{
                color: colors[theme].text,
                marginTop: 20,
                fontWeight: "600",
                fontSize: 16,
              }}
            >
              {dict.challenges_completed}
            </Text>
          </View>
          <DView
            style={{
              flexDirection: "row",
              justifyContent: "space-evenly",
              marginTop: [10, -20],
              flex: 1,
            }}
          >
            <View
              style={[
                styles.box,
                { backgroundColor: colors[theme].gameButtonBg },
              ]}
            >
              <Text
                style={{ color: "#26C97A", fontWeight: "500", fontSize: 52 }}
              >
                {tour.challengesWon}
              </Text>
              <Text
                style={{ color: "#26C97A", fontWeight: "500", fontSize: 12 }}
              >
                {dict.won}
              </Text>
            </View>
            <View
              style={[
                styles.box,
                { backgroundColor: colors[theme].gameButtonBg },
              ]}
            >
              <Text
                style={{ color: "#DD4D4D", fontWeight: "500", fontSize: 52 }}
              >
                {tour.challengesLost}
              </Text>
              <Text
                style={{ color: "#DD4D4D", fontWeight: "500", fontSize: 12 }}
              >
                {dict.failed}
              </Text>
            </View>
            <View
              style={[
                styles.box,
                { backgroundColor: colors[theme].gameButtonBg },
              ]}
            >
              <Text
                style={{
                  color: colors[theme].buttonBorder,
                  fontWeight: "500",
                  fontSize: 52,
                }}
              >
                {tour.totalChallenges -
                  tour.challengesLost -
                  tour.challengesWon}
              </Text>
              <Text
                style={{
                  color: colors[theme].buttonBorder,
                  fontWeight: "500",
                  fontSize: 12,
                }}
              >
                {dict.left}
              </Text>
            </View>
          </DView>
        </DView>
        {tour.stops.map((s, ks) => (
          <View
            key={s.stopID}
            style={[
              styles.box,
              {
                backgroundColor: colors[theme].buttonBorder,
                padding: 0,
                alignItems: "flex-start",
              },
            ]}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                opacity: tour.isStopHidden && !isStopLocked(ks) ? 0.2 : 1,
              }}
            >
              <View
                style={{
                  backgroundColor: colors[theme].text,
                  padding: 8,
                  borderTopLeftRadius: 8,
                  width: 46,
                  opacity: 0.8,
                  marginRight: 10,
                }}
              >
                <Text
                  style={{
                    color: colors[theme].bg,
                    textAlign: "center",
                    fontSize: 24,
                    fontWeight: "600",
                  }}
                >
                  {s.stopOrder}
                </Text>
              </View>
              <Text
                style={{
                  color: colors[theme].text,
                  fontWeight: "600",
                  fontSize: 16,
                  opacity: 0.8,
                }}
              >
                {tour.isStopHidden && !isStopLocked(ks) ? dict.locked : s.name}
              </Text>
            </View>
            {tour.isStopHidden && !isStopLocked(ks) ? (
              <View
                style={{
                  backgroundColor: colors[theme].bg,
                  width: "100%",
                  borderBottomLeftRadius: 8,
                  borderBottomRightRadius: 8,
                }}
              >
                <Text
                  style={{
                    color: colors[theme].text,
                    flex: 1,
                    opacity: 0.5,
                    padding: 15,
                  }}
                >
                  {dict.complete_to_unlock}
                </Text>
              </View>
            ) : (
              <View
                style={{
                  backgroundColor: colors[theme].bg,
                  width: "100%",
                  borderBottomLeftRadius: 8,
                  borderBottomRightRadius: 8,
                }}
              >
                {s.challenges.map((c, k) => (
                  <TouchableOpacity
                    onPress={() => {
                      DeviceEventEmitter.emit("go-to-stop", ks);
                      DeviceEventEmitter.emit("switch-game-and-stop", ks, k);
                      // setTimeout(() => {
                      //   navigation.navigate('Challenges', { k });
                      // }, 50);

                      setInGameStats(false);
                    }}
                    key={c.challengeID}
                  >
                    <View
                      style={{
                        marginHorizontal: 14,
                        borderBottomWidth:
                          k === s.challenges.length - 1 ? 0 : 1,
                        borderBottomColor: colors[theme].buttonBorder,
                        paddingVertical: 14,
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          marginRight: 10,
                          color: colors[theme].text,
                          flex: 1,
                          opacity:
                            c.state === "failed" || c.state === "correct"
                              ? 1
                              : 0.5,
                        }}
                      >
                        {c.question}
                      </Text>
                      {(c.state === "failed" || c.state === "correct") && (
                        <View
                          style={{
                            backgroundColor:
                              c.state === "correct" ? "#26C97A" : "#DD4D4D",
                            paddingVertical: 2,
                            paddingHorizontal: 4,
                            borderRadius: 10,
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Icon
                            name={
                              c.state === "correct"
                                ? "md-checkmark-sharp"
                                : "md-close-sharp"
                            }
                            size={16}
                            color={"#FFF"}
                          />
                          <Text
                            style={{
                              color: "#FFF",
                              fontWeight: "600",
                              marginLeft: 2,
                            }}
                          >
                            {c.state === "correct" ? c.score : "0"}
                          </Text>
                        </View>
                      )}
                    </View>
                  </TouchableOpacity>
                ))}
              </View>
            )}
          </View>
        ))}
        <View style={{ height: 10 }} />
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  box: {
    borderRadius: 8,
    padding: 16,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
    alignItems: "center",
    justifyContent: "space-between",
    margin: 7,
  },
});
